import { render, staticRenderFns } from "./VerificaIscrizione.vue?vue&type=template&id=fc2ea078&scoped=true&"
import script from "./VerificaIscrizione.vue?vue&type=script&lang=js&"
export * from "./VerificaIscrizione.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc2ea078",
  null
  
)

export default component.exports